import React, { useEffect } from "react";
import Login from "./Login";
import Register from "./Register";
import { Switch } from "react-router-dom";
import Recover from "./Recover";
import PrivateRoute from "./Route/PrivateRoute";
import PublicRoute from "./Route/PublicRoute";
import Home from "./HomeV2";
import Profile from "./Profile";
import Activation from "./Activation";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers';

import Contact from "./Contact";
import Dashboard from "./admin/Dashboard";
import Blocked from "./Blocked";
import SearchUser from "./admin_premium/SearchUser";
import Course from "./checkout/Course";
import LettersPage from "./pages/LettersPage";
import styled from "styled-components";
import UniqueDeviceMiddleware from "./middlewares/UniqueDeviceMiddleware";
import PrivacyPolicy from "./Privacidad";
import DeleteAccountSteps from "./DeleteAccount";
import CheckoutPage from "./checkout/v2/CheckoutPage";
import CheckoutPageManager from "./checkout/v2/CheckoutPageManager";
import { TeacherApp } from "../app/pages/TeacherApp/TeacherApp.component";
import { AuthTeacher } from "../app/pages/AuthTeacher/AuthTeacher.component";
import {Dashboard as TeacherDashboard} from '../app/pages/Teacher/Dashboard/Dashboard.component';
import {Cartas as TeacherCartas} from '../app/pages/Teacher/Cartas/Cartas.component';

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Switch>
        <PublicRoute
          exact
          path="/teacher"
          component={() => (
            <TeacherApp>
              <AuthTeacher>
                <TeacherCartas />
              </AuthTeacher>
            </TeacherApp>
          )}
        />
        <PublicRoute
          exact
          path="/teacher/cartas"
          component={() => (
            <TeacherApp>
              <AuthTeacher>
                <TeacherCartas />
              </AuthTeacher>
            </TeacherApp>
          )}
        />
        <PublicRoute path="/privacy" component={PrivacyPolicy} />
      <PublicRoute path="/deleteaccount" component={DeleteAccountSteps} />
        <PublicRoute onlyAnonymous path="/login" component={Login} />
        <PublicRoute onlyAnonymous path="/register" component={Register} />
        <PublicRoute onlyAnonymous path="/recover" component={Recover} />
        <PublicRoute
          path="/search"
          component={() => <SearchUser fullPage={true} />}
        />
        {/* <PublicRoute path="/cartas" component={() => <LettersTemp />} /> */}

        <PrivateRoute path="/blocked" component={Blocked} />
        <PrivateRoute path="/admin" component={Dashboard} />
        <PrivateRoute path="/contact" component={() => <Contact />} />

        <PrivateRoute path="/profile" component={() => <Profile />} />

        <PrivateRoute path="/activation" component={() => <Activation />} />

        <PublicRoute
          path={["/aleman-para-turistas/:checkoutPageId"]}
          component={Course}
        />

        <PublicRoute
          path={["/checkout/:publicId"]}
          component={CheckoutPageManager}
        />
        <PublicRoute path={["/checkout"]} component={CheckoutPage} />
        <PrivateRoute path={["/:courseId", "/"]} component={() => <Home />} />
      </Switch>
    </LocalizationProvider>
  );
};

const LettersTemp = () => {
  return (
    <Container>
      <LettersPage />
    </Container>
  );
};

const Container = styled.div`
  max-width: 500px;
  margin: 25px auto 0px auto;
`;

export default App;
